import { type JobCardStatus, JOB_CARD_STATUS_CONFIG } from '@jobos/shared';
import { cn } from '@/lib/utils';
import { unknownStatusConfig } from './unknownStatus';

interface JobCardStatusBadgeProps {
  status: JobCardStatus | null | undefined;
  className?: string;
}

export function JobCardStatusBadge({ status, className }: JobCardStatusBadgeProps) {
  const effective = status ?? 'not_started';
  // ?? — the column is plain text, so an unrecognised value is possible.
  const config = JOB_CARD_STATUS_CONFIG[effective] ?? unknownStatusConfig(effective);
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-medium border text-center min-w-[100px]',
        config.className,
        className,
      )}
    >
      {config.label}
    </span>
  );
}
